<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import CheckboxDefault from '@/components/form/CheckboxDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'CheckboxForm',

  components: {
    InputLeadFormWrapper,
    CheckboxDefault,
  },

  props: {
    /**
     * 初期選択状態が bind される value
     */
    modelValue: {
      type: Array as PropType<MultiSelect>,
      required: true,
    },

    /**
     * 選択肢の項目情報
     */
    items: {
      type: Array as PropType<SelectItem[]>,
      required: true,
    },

    /**
     * 何列表示か
     */
    cols: {
      type: Number as PropType<1 | 2 | 3 | 4 | 5 | 6>,
      default: 3,
    },

    ...formDefaultProps,
  },

  emits: ['update:modelValue'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :description="description"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme"
    is-select-type>
    <CheckboxDefault
      :model-value="modelValue"
      :name="name"
      :items="items"
      :cols="cols"
      :is-disabled="isDisabled"
      :is-error="hasError"
      @update:model-value="$emit('update:modelValue', $event)" />
  </InputLeadFormWrapper>
</template>
